<app-header *ngIf="user" [user]="user"></app-header>
<router-outlet></router-outlet>
<!--<app-footer></app-footer>-->
<app-toasts></app-toasts>
